/**
 * usePublishSite hook
 *
 * TanStack mutation wrapping `billingApi.publishSite`. The billing helpers
 * throw ApiClientError on failure, so TanStack's `onSuccess`/`onError`
 * semantics line up with HTTP success/failure.
 */

import { useMutation, useQueryClient } from '@tanstack/react-query';
import { publishSite } from '../api/billingApi';

interface PublishResult {
  status: string;
  checkoutUrl: string | null;
}

export function usePublishSite() {
  const queryClient = useQueryClient();
  return useMutation<PublishResult, Error, string>({
    mutationFn: (siteId) => publishSite(siteId),
    onSuccess: (_, siteId) => {
      queryClient.invalidateQueries({ queryKey: ['sites', siteId] });
      queryClient.invalidateQueries({ queryKey: ['sites'] });
    },
  });
}
